import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import CircularProgress from '@mui/material/CircularProgress';


interface BtnProps{
    color?: string,
    width?: number,
    height?: number,
    hoverColor?: string,
    disabled?: boolean,
    outline?: boolean | undefined | string,
    bordercolor?: string,
    borderradius?: number,
    loading?: boolean
}

const NavBtn = styled(Link)<BtnProps>`
display: flex;
align-items: center;
justify-content: center;
border-radius: ${props=> props.borderradius ? props.borderradius : 4}px;
border: ${props => props.bordercolor ? `1px solid ${props.bordercolor}` : props.outline ? '1px solid white' : '0'};
border-color: ${props=> props.bordercolor};
cursor: pointer;
margin: 2px;
width: ${props=> props.width ? props.width : 180}px;
height: ${props=> props.height ? props.height : 46}px;
background-color: ${props=> props.outline ? 'rgba(0,0,0,0)' : props.color ? props.color : '#494D60'};
outline: none;
user-select: none; /* supported by Chrome and Opera */
-webkit-user-select: none; /* Safari */
-khtml-user-select: none; /* Konqueror HTML */
-moz-user-select: none; /* Firefox */
-ms-user-select: none; /* Internet Explorer/Edge */
transition-duration: 0.20s;
transition-property: transform, background-color;
text-decoration: none!important;
&:hover{
    background-color: #494D90;
}
`

const Btn = styled.button<BtnProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${props=> props.borderradius ? props.borderradius : 4}px;
    border: ${props => props.bordercolor ? `1px solid ${props.bordercolor}` : props.outline ? '1px solid white' : '0'};
    border-color: ${props=> props.bordercolor};
    cursor: pointer;
    margin: 2px;
    width: ${props=> props.width ? props.width : 180}px;
    height: ${props=> props.height ? props.height : 46}px;
    background-color: ${props=> props.outline ? 'rgba(0,0,0,0)' : props.color ? props.color : '#494D60'};
    outline: none;
    user-select: none; /* supported by Chrome and Opera */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    transition-duration: 0.20s;
    transition-property: transform, background-color;
    text-decoration: none!important;
    &:hover{
        background-color: ${props=> props.hoverColor ? props.hoverColor : '#494D90'};
    }
`

interface TextProps{
    fontSize?: number
}

const Text = styled.p<TextProps>`
font-size: ${props=>props.fontSize ? props.fontSize : 14}px;
cursor: pointer;
transition-property: transform, color;
transition-duration: 0.20s;
outline: none;
user-select: none; /* supported by Chrome and Opera */
-webkit-user-select: none; /* Safari */
-khtml-user-select: none; /* Konqueror HTML */
-moz-user-select: none; /* Firefox */
-ms-user-select: none; /* Internet Explorer/Edge */
color: white;
text-decoration: none!important;
`   

interface Props {
    
    onPress?: ()=> void,
    color?: string,
    width?: number,
    height?: number,
    hoverColor?: string,
    nav?: boolean,
    fontSize?: number,
    disabled?: boolean,
    style?: React.CSSProperties,
    outline?: boolean | undefined | string,
    bordercolor?: string,
    borderRadius?: number,
    to?: string,
    loading?: boolean,
    persent?: number
}


export const Button: React.FC<Props> = (props) => {
    
    
    return (
        props.to ?(
        <NavBtn 
            style={props.style}
            color={props.color}
            width={props.width}
            height={props.height}
            outline={props.outline}
            bordercolor={props.bordercolor}
            borderradius={props.borderRadius}
            to={props.to}
            disabled={props.loading}
        >
            {props.loading ? 
                <CircularProgress color="success"  size={15}/> :
                <Text fontSize={props.fontSize}>{props.children}</Text>
            }
        </NavBtn>) : (
            <Btn
            style={props.style}
            color={props.color}
            width={props.width}
            height={props.height}
            outline={props.outline}
            bordercolor={props.bordercolor}
            borderradius={props.borderRadius}
            onClick={props.onPress}
            hoverColor={props.hoverColor}
            disabled={props.disabled || props.loading}
            >
                {props.loading ? 
                    (props.persent ? <CircularProgress color='error' size={25} variant="determinate" value={props.persent} /> : <CircularProgress color="error"  size={17}/>) :
                    <Text fontSize={props.fontSize}>{props.children}</Text>
                }
            </Btn>
        ) 
    )
}